import { render } from "./Registered.vue?vue&type=template&id=2333228c"
import script from "./Registered.vue?vue&type=script&lang=js"
export * from "./Registered.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__